// ══════════════ MESSAGERIE SIMPLE ══════════════
// Extrait de GerantClientUI.jsx (refacto étape 1, 06/07/2026).
// Brique partagée utilisée par GerantUI, StaffUI, ProvUI, ClientUI.
// Feuille : aucune dépendance vers un composant interne de GerantClientUI.
import React, { useState, useEffect, useRef } from 'react';
import { ft, now, formatFileSize } from '../utils.js';
import { Ic } from './Ic.jsx';
import { notifEventBus } from '../notifBus.js';
import { uploadMsgAttachment } from '../supabase.js';
import { MSG_ATT_MAX_SIZE, MSG_ATT_MAX_COUNT } from '../constants.js';

export function SimpleChat({sess,msgs,setMsgs,accent,senderName}){
  const tid=`${sess.type}:${sess.id}`;
  const myM=msgs.filter(m=>m.tid===tid).sort((a,b)=>new Date(a.ts)-new Date(b.ts));
  const[inp,setInp]=useState('');
  const[pending,setPending]=useState([]); // pièces jointes en cours de sélection/upload pour le message en cours
  const fileRef=useRef(null);
  const ref=useRef(null);
  const addFiles=(files)=>{
    const list=Array.from(files||[]);
    if(!list.length)return;
    setPending(prev=>{
      const room=MSG_ATT_MAX_COUNT-prev.length;
      if(room<=0)return prev;
      const toAdd=list.slice(0,room).map(file=>{
        const id='p'+Date.now()+Math.random().toString(36).slice(2,7);
        if(file.size>MSG_ATT_MAX_SIZE)return{id,file,status:'err',err:'Trop volumineux (max 15 Mo)'};
        return{id,file,status:'up'};
      });
      toAdd.filter(p=>p.status==='up').forEach(p=>{
        uploadMsgAttachment(p.file,tid)
          .then(result=>setPending(prev2=>prev2.map(x=>x.id===p.id?{...x,status:'ok',result}:x)))
          .catch(e=>setPending(prev2=>prev2.map(x=>x.id===p.id?{...x,status:'err',err:e.message||'Échec de l\'envoi'}:x)));
      });
      return[...prev,...toAdd];
    });
  };
  const removePending=id=>setPending(prev=>prev.filter(x=>x.id!==id));
  // ⚠️ Corps en accolades OBLIGATOIRE : avec un corps implicite (`()=>ref.current?.scroll…`),
  // l'effet renvoie le résultat de scrollIntoView à React, qui le prend pour une fonction de
  // nettoyage et l'appelle au démontage / à chaque changement de dépendance. La spec dit que
  // scrollIntoView renvoie undefined (cas inoffensif), mais une extension de navigateur ou un
  // polyfill de défilement fluide peut la remplacer par une version qui renvoie une valeur —
  // et là React plante en page blanche (`TypeError: n is not a function`, pile 100 % interne
  // à React). Diagnostiqué le 28/07/2026 après plusieurs pages blanches en production.
  useEffect(()=>{ ref.current?.scrollIntoView({behavior:'smooth'}); },[myM.length]);
  useEffect(()=>{const u=msgs.filter(m=>m.tid===tid&&!m.ru);if(u.length)setMsgs(msgs.map(m=>m.tid===tid?{...m,ru:true}:m));},[]);
  const attOk=pending.filter(p=>p.status==='ok').map(p=>p.result);
  const hasUploading=pending.some(p=>p.status==='up');
  const send=()=>{
    if(hasUploading)return; // sécurité en plus du bouton désactivé
    if(!inp.trim()&&attOk.length===0)return;
    const q=inp.toLowerCase();
    const ct=inp.trim();
    const nm={id:'m'+Date.now(),tid,ft:sess.type,fid:sess.id,fName:senderName||sess.name||null,ct,ts:now(),ra:false,ru:true,...(attOk.length?{att:attOk}:{})};
    let upd=[...msgs,nm];
    if(/^(bonjour|salut)\W*$/i.test(q.trim())){upd.push({id:'m'+(Date.now()+1),tid,ft:'bot',fid:'bot',ct:'Bonjour ! 👋 Je peux aider avec codes, horaires ou adresses.',ts:new Date(Date.now()+1000).toISOString(),ra:true,ru:false,isBot:true});}
    else if(/^(merci)\W*$/i.test(q.trim())){upd.push({id:'m'+(Date.now()+1),tid,ft:'bot',fid:'bot',ct:'Avec plaisir ✦',ts:new Date(Date.now()+1000).toISOString(),ra:true,ru:false,isBot:true});}
    else{
      nm.esc=true;
      // ─── notif : message_recu (non-admin → admin) ───
      // Le destinataire est l'Admin : on émet avec toUserType='admin' pour que
      // le rôle 'assignee' du panneau résolve bien sur l'admin.
      notifEventBus.emit('message_recu',{
        fromName:senderName||sess.name||'?', fromType:sess.type, fromId:sess.id,
        toUserType:'admin', toUserId:'admin',
        body:ct||`📎 ${attOk.length} pièce(s) jointe(s)`,
        summary:`Message de ${sess.name||sess.type} → Admin`
      });
    }
    setMsgs(upd);setInp('');setPending([]);
  };
  return(<div>
    <div className="D" style={{fontSize:17,marginBottom:4}}>Messagerie</div>
    <div style={{fontSize:11,color:'var(--si)',marginBottom:12}}>Questions simples → réponse auto 🤖 · Sinon → transmis à l'admin</div>
    <div className="card" style={{overflow:'hidden'}}><div style={{display:'flex',flexDirection:'column',maxHeight:420}}>
      <div style={{padding:'9px 13px',borderBottom:'1px solid var(--li)',borderTop:`3px solid ${accent}`}}><div className="D" style={{fontSize:13}}>La Conciergerie</div></div>
      <div style={{flex:1,overflowY:'auto',padding:12,background:'var(--bg)',display:'flex',flexDirection:'column',gap:8,minHeight:180}}>
        {myM.length===0&&<div className="empty" style={{padding:'16px'}}>Aucun message</div>}
        {myM.map(m=>{const iM=m.ft===sess.type&&m.fid===sess.id,iB=m.ft==='bot';return <div key={m.id} className={`bbl ${iM?'bme':iB?'bbt':'bth'}`}>{m.ct&&<div style={{whiteSpace:'pre-wrap'}}>{m.ct}</div>}{m.att&&m.att.length>0&&<div style={{display:'flex',flexDirection:'column',gap:6,marginTop:m.ct?6:0}}>{m.att.map((a,i)=>a.type&&a.type.startsWith('image/')?<a key={i} href={a.url} target="_blank" rel="noopener noreferrer"><img src={a.url} alt={a.name||'photo'} style={{maxWidth:180,maxHeight:180,borderRadius:8,display:'block'}}/></a>:<a key={i} href={a.url} target="_blank" rel="noopener noreferrer" style={{display:'flex',alignItems:'center',gap:6,fontSize:11,padding:'6px 9px',background:'rgba(0,0,0,.06)',borderRadius:7,textDecoration:'none',color:'inherit'}}><Ic n="rp" c="w-4 h-4"/><span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:140}}>{a.name}</span>{a.size?<span style={{opacity:.6}}>{formatFileSize(a.size)}</span>:null}</a>)}</div>}{iB&&<div style={{fontSize:9,opacity:.6,marginTop:3}}>Auto 🤖</div>}</div>;})}
        <div ref={ref}/>
      </div>
      {pending.length>0&&<div style={{display:'flex',flexWrap:'wrap',gap:6,padding:'8px 12px 0'}}>
        {pending.map(p=><div key={p.id} style={{display:'flex',alignItems:'center',gap:5,fontSize:11,padding:'4px 8px',borderRadius:999,background:p.status==='err'?'#fde0e0':'var(--bg)',border:'1px solid var(--li)'}}>
          <span style={{maxWidth:100,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{p.file.name}</span>
          {p.status==='up'&&<span style={{opacity:.6}}>…</span>}
          {p.status==='err'&&<span style={{color:'var(--dg)'}} title={p.err}>⚠</span>}
          {p.status==='ok'&&<span style={{color:'var(--ok)'}}>✓</span>}
          <button onClick={()=>removePending(p.id)} type="button" style={{border:'none',background:'none',cursor:'pointer',padding:0,lineHeight:1,color:'inherit'}}><Ic n="x" c="w-3 h-3"/></button>
        </div>)}
      </div>}
      <div style={{padding:'9px 12px',borderTop:'1px solid var(--li)',background:'var(--wh)',display:'flex',gap:6,alignItems:'flex-end'}}>
        <input ref={fileRef} type="file" multiple accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt" style={{display:'none'}} onChange={e=>{addFiles(e.target.files);e.target.value='';}}/>
        <button onClick={()=>fileRef.current?.click()} type="button" className="btn bor sm" title="Joindre un fichier"><Ic n="atc" c="w-4 h-4"/></button>
        <textarea value={inp} onChange={e=>setInp(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();send();}}} placeholder="Ton message..." rows="1" style={{resize:'none',minHeight:34,maxHeight:70,fontSize:13}}/>
        <button onClick={send} className="btn bor sm" disabled={(!inp.trim()&&attOk.length===0)||hasUploading}><Ic n="sd" c="w-4 h-4"/></button>
      </div>
    </div></div>
  </div>);
}
